module.exports = "/_next/static/images/all4-negative-8f75765f71fb3d66a02f37c8032892e6.png";